/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 40);
/******/ })
/************************************************************************/
/******/ ({

/***/ 15:
/***/ (function(module, exports) {

/**
 * The feline queen game is using a scratchcards paytable
 * The api delivers a matrix of 9 symbols rather than the needed 3.
 * We always take the first 3 symbols from the matrix unless it is
 * a win in which case we make an array of 3 winning prizes.
 *
 * e.g.
 * From: [5, 1, 1, 9, 7, 8, 4, 2, 5]
 * To:   [5, 1, 1]
 *
 * From: [5, 1, 1, 9, 1, 8, 4, 2, 5]
 * To:   [1, 1, 1]
 *
 */

module.exports = {
    title: 'Feline Queen',
    baseMultiplier: 0.2,

    font: 'ProximaNova',
    fontVariations: ':n4,n7',
    secondaryFont: 'SignPainter',

    parallax: 0,

    backgroundAnchor: {
        x: 0.5,
        y: 0.5
    },

    hasBackgroundView: true,
    hasForegroundView: false,

    logoYTitle: 0,
    logoZTitle: 0,

    ticketIdX: 0,

    bgColor: 0x0e2b5f,
    primaryColor: 0xf5a620,

    volumes: {
        music: 0.8,
        win: 0.8,
        'sas-louder': 1,
        'spin-button': 0.4,
        'stop-1': 1.0,
        'stop-2': 0.8,
        'stop-3': 0.7
    },

    styles: {
        introText: {
            fontFamily: 'ProximaNova',
            fontSize: 16,
            fontWeight: 400,
            fill: 0xFFFFFF,
            align: 'center',
            lineHeight: 23,
            wordWrap: true,
            wordWrapWidth: 260,
            stroke: 0x000000,
            strokeThickness: 3,
            lineJoin: 'round'
        }
    }
};

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "themes/fq/img/logo-title@2x.png";

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = {"FelineQueen":"fq"}

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sass_game__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sass_game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sass_game__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_themes__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_themes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_themes__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Class for loader.
 */

var Loader = function () {
    /**
     * Constructs the object.
     */
    function Loader() {
        _classCallCheck(this, Loader);

        var gameCode = UTIL.getQueryParam(['gamecode', 'gc']);

        var themeCode = this.getTheme(gameCode);

        window.__themeCode = themeCode;
        window.__theme = __webpack_require__(15);
        window.__isMobile = this.isMobile(gameCode);

        var primaryColor = UTIL.hexToString(__theme.primaryColor);
        var bgColor = UTIL.hexToString(__theme.bgColor);

        var logo = __webpack_require__(2);

        this.themeLoader(__theme.title, logo, bgColor, primaryColor);
    }

    /**
     * Themes the loading screen
     *
     * @param  {string}  title         The title
     * @param  {string}  logo          The logo url
     * @param  {string}  bgColor       The background color hexCode
     * @param  {string}  primaryColor  The primary color hexCode
     */


    _createClass(Loader, [{
        key: 'themeLoader',
        value: function themeLoader(title, logo, bgColor, primaryColor) {
            // version the logo
            logo = logo + '?v=' + window.__version;

            document.addEventListener('DOMContentLoaded', function () {
                document.title = title;
                var className = __isMobile ? 'mobile' : 'desktop';

                document.body.classList.add(className);

                document.getElementById('logo').style.backgroundImage = 'url(' + logo + ')';
                document.getElementById('initial-loader').style.backgroundColor = bgColor;
                document.getElementById('progress-bar').style.backgroundColor = primaryColor;

                document.getElementById('progress-percent').style.color = primaryColor;
            });
        }

        /**
         * Gets the theme from the Game Code
         *
         * @param  {string}             gameCode  The game code
         * @return {(object|string)}  The theme.
         */

    }, {
        key: 'getTheme',
        value: function getTheme(gameCode) {
            for (var gc in __WEBPACK_IMPORTED_MODULE_1_themes___default.a) {
                var tc = __WEBPACK_IMPORTED_MODULE_1_themes___default.a[gc];
                var re = new RegExp(gc, 'gi');
                var match = gameCode.match(re);

                if (match) {
                    return tc;
                }
            }

            return null;
        }

        /**
         * Determines if mobile.
         *
         * @param  {string}   gameCode  The game code
         * @return {boolean}  True if mobile, False otherwise.
         */

    }, {
        key: 'isMobile',
        value: function isMobile(gameCode) {
            var isMobileGameCode = gameCode.match(/_Mobile/);

            if (isMobileGameCode) {
                return true;
            }

            var check = false;

            function test(a) {
                /* eslint-disable max-len*/
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                    check = true;
                }

                /* eslint-enable max-len*/
            }

            test(navigator.userAgent || navigator.vendor || window.opera);

            return check;
        }
    }]);

    return Loader;
}();

new Loader(); // eslint-disable-line

/***/ })

/******/ });


// WEBPACK FOOTER //
// b-loader.js